const UIDataTableCellOrderSyncStatus = ({ info }) => 
{
    const { hasError, status } = info.row.original

    const getStatusBadgeClass = (status) => {
      if (hasError)
        return "bg-danger";
      
      const statusClasses = {
        queued: "bg-info",
        started: "bg-primary",
        completed: hasError ? "bg-danger" : "bg-success",
      };

      return statusClasses[status.toLowerCase()] || "bg-info"; // Padrão se não encontrar
    };

    return <span className={`badge badge-sm rounded-pill ${getStatusBadgeClass(status)}`}>{status}</span>;
}

export default UIDataTableCellOrderSyncStatus
